import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { CarfaxService, ConfigurationState, SetCarfaxState } from 'remarketing-angular-library';
import { BannerConfig, BannerMode, BannerComponent } from '../../../shared/components/banner/banner.component';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { get } from 'lodash';
import { CommonInterstitialModalComponent, CommonInterstitialModalTranslations } from 'remarketing-ui-components-lib';


@Component({
    selector: 'app-service-carfax',
    templateUrl: './service-carfax.component.html',
    styleUrls: ['./service-carfax.component.scss'],
    imports: [TranslocoDirective, BannerComponent, CommonInterstitialModalComponent]
})
export class ServiceCarfaxComponent implements OnInit, OnDestroy {
  readonly carfaxConstant = 'CARFAX';
  isUserLoggedIn: boolean;
  banner: BannerConfig = {
    text: '',
    mode: BannerMode.CARFAX,
    showIcon: true,
    showUndo: false
  };
  textSuccessfullyLogged: string;
  textLoggedOut: string;
  textUnableComplete: string;
  @ViewChild(CommonInterstitialModalComponent) commonInterstitialModalComponent: CommonInterstitialModalComponent;
  commonInterstitialModalTranslations: CommonInterstitialModalTranslations = {
    cancelBtn: '',
    continueBtn: '',
    subtext1: '',
    subtext2: '',
    text: '',
    title: ''
  };

  private readonly destroyed$ = new Subject();

  get tenantFullName(): string {
    return get(this.store.selectSnapshot(ConfigurationState.configuration), 'tenantFullName', '').replace('Canada','');
  }

  constructor(
    private readonly carfaxService: CarfaxService,
    private readonly store: Store,
    private readonly translocoService: TranslocoService
  ) {}

  ngOnInit() {
    this.getTranslations();
    window.addEventListener('storage', (event) => {
      if (event.storageArea !== localStorage) return;
      const loggedInStatus = window.localStorage.getItem('carfaxLoggedIn');
      if (loggedInStatus.toLowerCase() === 'true') {
        this.banner.mode = BannerMode.CARFAX;
        this.banner.text = this.textSuccessfullyLogged;
        this.isUserLoggedIn = true;
      }
    });

    this.getCarfaxLoggedInStatus();
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  getCarfaxLoggedInStatus() {
    this.carfaxService.getLoggedInStatus().pipe(takeUntil(this.destroyed$)).subscribe(statusDto => {
      this.isUserLoggedIn = statusDto.userLoggedIn;
    }, () => {
      this.isUserLoggedIn = false;
    });
  }

  changeCarfaxStatus(confirm?: boolean) {
    if (this.isUserLoggedIn === true ) {
      if(confirm){
        this.carfaxService.revokeCarfaxAccess().pipe(takeUntil(this.destroyed$)).subscribe(revokeDto => {
          window.open(revokeDto.logoutUrl);
          window.localStorage.setItem('carfaxLoggedIn', 'false');
          this.isUserLoggedIn = false;
          this.banner.mode = BannerMode.CARFAX;
          this.banner.text = this.textLoggedOut;
        }, () => {
          this.banner.mode = BannerMode.ERROR;
          this.banner.text = this.textUnableComplete;
        });
      }
    } else {
      this.carfaxService.getCarfaxAuthUrl().pipe(takeUntil(this.destroyed$)).subscribe(authResponseDto => {
        this.store.dispatch(new SetCarfaxState(authResponseDto.nonce, null));
        confirm ? window.open(authResponseDto.loginUrl) : null;
      }, () => {
        this.banner.mode = BannerMode.ERROR;
        this.banner.text = this.textUnableComplete;
      });
    }
  }

  openIntersiteDisclosure() {
    this.commonInterstitialModalComponent.show();
  }

  getTranslations() {
    const keyParams = {
      'UIComponents.commonInterstitialModal': {},
      'profileManagement.serviceCarfax': {}
    };

    this.translocoService.selectTranslateObject(keyParams).pipe(takeUntil(this.destroyed$)).subscribe(translate => {
      this.commonInterstitialModalTranslations = translate[0];
      this.textSuccessfullyLogged = translate[1].textSuccessfullyLogged;
      this.textLoggedOut = translate[1].textLoggedOut;
      this.textUnableComplete = translate[1].textUnableComplete;
    });
  }
}
